// Module
var code = "<avatar :object=\"team\" :name=\"team ? team.Name : ''\"></avatar> ";
// Exports
export default code;